export interface Env {
    "PUBLIC_SEARCH_teamsAPI": string;
    "PUBLIC_SEARCH_teamURL": string;
    "PUBLIC_SEARCH_root": string;
}

export const getEnvConfig = ():Env => {
    return (window as any)['__env__']
}
